<template>
 <div class="myworks">
  <my-header></my-header>
  <my-project-list :projectList="jsonData"></my-project-list>
  <my-footer></my-footer>
 </div>
</template>

<script>
 import MyHeader from "@/components/MyHeader"
 import MyProjectList from "./components/MyProjectList.vue";
 import MyFooter from "./components/MyFooter.vue";
 import data from '@/data';

 export default {
  components: {
   MyHeader,
   MyProjectList,
   MyFooter
  },
  data() {
   return {
    jsonData: []
   }
  },
  mounted() {
   this.loadJsonData();
  },
  methods: {
   loadJsonData() {
    this.jsonData = data;
   }
  },
 }
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@500&display=swap');
* {
 margin: 0;
 padding: 0;
 box-sizing: border-box;
 font-family: 'Nunito', sans-serif;
}
body {
 background-color: #121212;
}
</style>